import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import VehicleRadio from '../VehicleRadio';
import YearInput from './YearInput';
import VehicleMake from './VehicleMake';
import VehicleModel from './VehicleModel';

const VehicleInfo = ({
  control,
  vehicleType,
}) => (
  <>
    <Box>
      <Typography variant="h3" sx={{ mt: '24px', mb: '8px' }}>
        Enter your vehicle information.
      </Typography>
      <Typography variant="body1">
        Select the type of vehicle you&apos;re seeking financing for and provide it&apos;s details.
      </Typography>
    </Box>
    <VehicleRadio control={control} />
    <ValidatedTextField
      name="vehicleYear"
      control={control}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: /^\d{4}$/,
          message: 'Please enter a valid year',
        },
      }}
    >
      <TextField
        fullWidth
        label="Year"
        InputProps={{
          inputComponent: YearInput,
        }}
      />
    </ValidatedTextField>
    <VehicleMake
      control={control}
      vehicleType={vehicleType}
    />
    <VehicleModel control={control} />
  </>
);

export default VehicleInfo;
